import React, { useEffect, useRef, useState } from 'react';
import './ClientLogs.css';

// Import all logos directly
import log1 from '../../../assets/client_logo/Flower-Emporium.jpg';
import log2 from '../../../assets/client_logo/India-House-Ajman.jpg';
import log3 from '../../../assets/client_logo/Karla-Electronics.jpg';
import log4 from '../../../assets/client_logo/Maaz-Tarvels.jpg';
import log5 from '../../../assets/client_logo/Mind-Creative.jpg';
import log6 from '../../../assets/client_logo/Petal-Box.jpg';
import log7 from '../../../assets/client_logo/Shriram-Enterprises.jpg';
import log8 from '../../../assets/client_logo/buy-flower-box.jpg';
import log9 from '../../../assets/client_logo/fsiksa.jpg';

const images = [log1, log2, log3, log4, log5, log6, log7, log8, log9];
const VISIBLE_LOGO_COUNT = 3;

const ClientLogs = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const sliderRef = useRef(null);
  const intervalRef = useRef(null);

  useEffect(() => {
    const startSlider = () => {
      intervalRef.current = setInterval(() => {
        setCurrentIndex(prevIndex => (prevIndex + 1) % (images.length - VISIBLE_LOGO_COUNT + 1));
      }, 3000);
    };

    startSlider();

    return () => {
      clearInterval(intervalRef.current);
    };
  }, []);
  // }, [images.length]);

  useEffect(() => {
    if (sliderRef.current) {
      const imageWidth = sliderRef.current.children[0]?.offsetWidth || 0;
      sliderRef.current.style.transform = `translateX(-${currentIndex * (imageWidth + 20)}px)`;
    }
  }, [currentIndex]);

  return (
    <div className="client-logs-container">
      <div className="client-logs-wrapper">
        <div className="client-logs-slider" ref={sliderRef}>
          {images.map((image, index) => (
            <img 
              key={`logo-${index}`}
              src={image}
              alt={`Client logo ${index + 1}`}
              className="client-logo"
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ClientLogs;